var chunkMapping = {
	"0": [
		4880
	],
	"148": [
		5069
	],
	"149": [
		5070
	],
	"152": [
		5073
	],
	"153": [
		5074
	],
	"154": [
		5075
	],
	"155": [
		5076
	],
	"156": [
		5077
	],
	"157": [
		5078
	],
	"158": [
		5079
	],
	"159": [
		5080
	],
	"160": [
		5081
	],
	"161": [
		5082
	],
	"162": [
		5083
	],
	"163": [
		5084
	],
	"164": [
		5085
	],
	"165": [
		5086
	],
	"166": [
		5087
	],
	"167": [
		5088
	],
	"168": [
		5089
	]
};
var idToExternalAndNameMapping = {
	"4880": [
		"default",
		"./Containers",
		3790
	],
	"5069": [
		"default",
		"./AsyncEventTracker",
		3790
	],
	"5070": [
		"default",
		"./HostWrapper",
		3790
	],
	"5073": [
		"default",
		"./CheckoutV3",
		3790
	],
	"5074": [
		"default",
		"./CheckoutConfirmation",
		3790
	],
	"5075": [
		"default",
		"./AuditDialog",
		3790
	],
	"5076": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3790
	],
	"5077": [
		"default",
		"./InvoiceDialog",
		3790
	],
	"5078": [
		"default",
		"./PaymentDueModal",
		3790
	],
	"5079": [
		"default",
		"./PaymentModal",
		3790
	],
	"5080": [
		"default",
		"./ContactCreditCards",
		3790
	],
	"5081": [
		"default",
		"./PaymentHistory",
		3790
	],
	"5082": [
		"default",
		"./PaymentConfigurations",
		3790
	],
	"5083": [
		"default",
		"./PaymentPreferences",
		3790
	],
	"5084": [
		"default",
		"./ManagePaymentProcessing",
		3790
	],
	"5085": [
		"default",
		"./MobilePaymentsWrapper",
		3790
	],
	"5086": [
		"default",
		"./Challenge",
		3790
	],
	"5087": [
		"default",
		"./ManagePaymentMethods",
		3790
	],
	"5088": [
		"default",
		"./LightspeedReports",
		3790
	],
	"5089": [
		"default",
		"./ShippingPromotionsListContainer",
		3790
	]
};
var idToRemoteMap = {
	"4880": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5069": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5070": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5073": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5074": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5075": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5076": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5077": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5078": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5079": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5080": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5081": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5082": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5083": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5084": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5085": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5086": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5087": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5088": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	],
	"5089": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3790
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}